export const plDocuments = document.querySelector(".pl-documents");
export let apiPath = plDocuments.dataset.documentssource;
export let productsPath = plDocuments.dataset.productssource;
export let subproductsPath = plDocuments.dataset.subproductssource;
export let productgroupsPath = plDocuments.dataset.productgroupssource;
export let validProductGroupNames;
export let validProductNames;
export let validSubproductNames;

export let productsJson;

export function setValidProductGroupNames(value) {
  validProductGroupNames = value;
}

export function setValidProductNames(value) {
  validProductNames = value;
}
export function setValidSubproductNames(value) {
  validSubproductNames = value;
}
